module.exports = __webpack_public_path__ + "e5d81ee8ae2a391f0d4a932db700b9d4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-2.png
// module id = 1634
// module chunks = 0